export default __webpack_public_path__ + "static/media/googleplay_black.97e366f7.svg";